/**
 * Created by Jerker Nord on 2020-04-08.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {BonusBunniesParsedInitData} from "../server/data/BonusBunniesParsedInitData";
import {BonusBunniesParsedGameData} from "../server/data/BonusBunniesParsedGameData";
import {BonusBunniesGameMode} from "../gamemode/BonusBunniesGameMode";
import {BonusBunniesBonusSpinsChestView} from "./BonusBunniesBonusSpinsChestView";
import {TimelineLite} from "gsap";

export class BonusBunniesBonusSpinsChestController {

    private _view:BonusBunniesBonusSpinsChestView;
    private _currentMode:string;
    private _nextMode:string;
    private _endBonusMultiplier:number;

    constructor() {
        this._view = new BonusBunniesBonusSpinsChestView();
        this.addFeatureEventHandlers();
    }

    private addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parseFeatureGameData(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, () => this.onSpinStart());
    }

    private onSpinStart():void {
        if((this._currentMode == BonusBunniesGameMode.BONUS_GAME || this._nextMode == BonusBunniesGameMode.BONUS_GAME) && this._endBonusMultiplier == 1) {
            this._view.rumbleChest();
        }
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        if(data.isRestoreState == true && this._currentMode == BonusBunniesGameMode.BONUS_GAME) {
            this._view.enableChest();
        }
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._endBonusMultiplier = data.endBonusMultiplier;
    }

    public getChestWinTimeline(valueToAdd:number):TimelineLite {
        return this._view.getChestWinAnimation(this._endBonusMultiplier, valueToAdd);
    }

    public loopRumbleChest():void{
        this._view.loopRumbleChest();
    }

    public stopLoopingRumbleChest():void{
        this._view.stopLoopingRumbleChest();
    }

    public enableChest():void {
        this._view.enableChest();
    }

    public disableChest():void {
        this._view.disableChest();
    }

    public setExtraReelActivated(value:boolean):void {
        this._view.extraReelActivated = value;
    }

    public setExtraRowActivated(value:boolean):void {
        this._view.extraRowActivated = value;
    }
}